module.exports = __webpack_public_path__ + "img/we-move-fast.797bec36.png";